import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContentCustom from './SnackbarContentCustom';
import snackbarContentCustomTypes from './SnackbarContentCustomTypes';


class SnackbarCustom extends Component {
    constructor(props){
        super(props);
        this.state = {
            open: this.props.open,
            type: this.props.type,
            message: this.props.message,
        };
    }

    handleOpen = (type, event, message) => {
        event.preventDefault();
        this.setState({ open: true, type: type, message: message });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render(){ 
        return (
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                open={this.state.open}
                autoHideDuration={4000}
                onClose={this.handleClose}
                ContentProps={{
                    'aria-describedby': 'snackbar-fab-message-id',
                }}
                id="saveState"
            >
                <SnackbarContentCustom variant={this.state.type} message={this.state.message} onClose={this.handleClose}/>
            </Snackbar>);
    }
}

SnackbarCustom.propTypes = {
  type: PropTypes.oneOf(Object.keys(snackbarContentCustomTypes)).isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

export default SnackbarCustom;


// WEBPACK FOOTER //
// ./src/components/custom/snackbar/SnackbarCustom.js